import { render, staticRenderFns } from "./RetailerProductPolicyModal.vue?vue&type=template&id=4586ca79"
import script from "./RetailerProductPolicyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetailerProductPolicyModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,RetailerProductModal: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/RetailerProduct/RetailerProductModal.vue').default})
